import { render, staticRenderFns } from "./news_rails_landscape.vue?vue&type=template&id=75e9fe50&scoped=true&"
import script from "./news_rails_landscape.vue?vue&type=script&lang=js&"
export * from "./news_rails_landscape.vue?vue&type=script&lang=js&"
import style0 from "./news_rails_landscape.vue?vue&type=style&index=0&lang=css&"
import style1 from "./news_rails_landscape.vue?vue&type=style&index=1&id=75e9fe50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75e9fe50",
  null
  
)

export default component.exports